import { isRunningInNativeApp } from '~/utils/browserInfo';

/**
 * Política de tracking do app vs. site (ENG-397).
 *
 * Dentro do app nativo (iOS e Android), NENHUM tracking de site de terceiros
 * (Meta/Facebook, Google/GTM, Kwai, Taboola, Microsoft Clarity, device
 * fingerprint) deve rodar — sempre, independente do App Tracking Transparency.
 * O objetivo é separar as métricas de app das de site e cumprir a App Store
 * (Guideline 5.1.1(iv)). Fora do app (navegador), o comportamento é inalterado.
 *
 * Fonte única consumida pelos gates de: pixels (`03-asyncLoad`), cookies FB e
 * captura de click-ids (`use-marketing-tracking`), fingerprint (`enter-site`
 * middleware) e o payload do `/collector` (`toApiPayload`).
 *
 * `isRunningInNativeApp()` é síncrono e lê `window.ReactNativeWebView`, que o
 * `react-native-webview` injeta ANTES do JS da página — logo o gate é
 * determinístico já no primeiro script (não há corrida de timing).
 */
export function useAppTrackingPolicy() {
  const isNativeApp = isRunningInNativeApp();
  const siteTrackingEnabled = computed<boolean>(() => !isNativeApp);

  return { isNativeApp, siteTrackingEnabled };
}
